var loader = function(){

	return new Promise(function(resolve, reject){
		
        window.OneSignal = window.OneSignal || [];
		
		OneSignal.push(function(){
			var oneSignal = OneSignal;
			//delete window.OneSignal; // !! can't do so since OneSignal internally relies on global
			resolve(oneSignal);
		});
		
		addScript({
			src: 'https://cdn.onesignal.com/sdks/OneSignalSDK.js',
			type: 'text/javascript',
			async: null
		}, null, null, reject);
	});
	
	function addScript(attribute, innerHtml, onload, onerror) {
		var s = document.createElement('script');
		for (var attr in attribute) {
			s.setAttribute(attr, attribute[attr] ? attribute[attr] : null)
		}
        s.innerHTML = innerHtml;
        s.onload = onload;
        s.onerror = onerror;
		document.head.appendChild(s);
	}
}

export default loader;


//////////////////
// WEBPACK FOOTER
// ./src/one-signal/one-signal-loader.js
// module id = 3
// module chunks = 0